enum SaleType {
  Auction = "Auction",
  InstantSale = "InstantSale",
  Offer = "Offer",
}

export default SaleType;
